// File: src/components/SEO.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  canonicalUrl?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogImage = '/logo512.png',
  ogUrl,
  canonicalUrl
}) => {
  const siteUrl = 'https://empowerfuture21.org'; // Replace with your actual domain when deployed
  const defaultTitle = 'Empower Future 21 (EF21) - Strengthening Education and Resilient Communities in Crisis-Affected Myanmar';
  const defaultDescription = 'Empower Future 21 (EF21) is a women-led Myanmar humanitarian and development organization working alongside conflict-affected communities to improve access to safe, inclusive, and quality education while strengthening community resilience.';
  
  const fullTitle = title ? `${title} | Empower Future 21 (EF21)` : defaultTitle;
  const fullDescription = description || defaultDescription;
  const fullOgUrl = ogUrl ? ogUrl : siteUrl;
  const fullCanonicalUrl = canonicalUrl ? canonicalUrl : siteUrl;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* OpenGraph / Facebook Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullOgUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullOgImage} />
      
      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullOgImage} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={fullCanonicalUrl} />
    </Helmet>
  );
};

export default SEO;

